import { useState, useEffect } from 'react';
import {
    getCommunicationList,
    addOrUpdateCommunication,
    deleteCommunication,
} from "../../../services/communicationAPI";
import { Communication } from "../../../data/Communication";

const useCommunication = () => {
    const [communication, setCommunication] = useState<Communication[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {


        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        setError(null); // Clear previous errors
        try {
            const data = await getCommunicationList();
            setCommunication(data);
        } catch (err: any) {
            setError("Failed to fetch communication. " + err.message);
        } finally {
            setLoading(false);
        }
    };
    const handleAdd = async (newType: Partial<Communication>) => {
        setLoading(true);
        setError(null);
        try {
            await addOrUpdateCommunication(newType as Communication); // Call API
            await fetchData(); // Refetch list after adding
        } catch (err: any) {
            setError("Failed to add communication. " + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (updatedType: Partial<Communication>) => {
        setLoading(true);
        setError(null);
        try {
            await addOrUpdateCommunication(updatedType as Communication); // Call API
            await fetchData(); // Refetch list after updating
        } catch (err: any) {
            setError("Failed to update communication. " + err.message);
        } finally {
            setLoading(false);
        }
    };


    const handleDelete = async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            await deleteCommunication(id);
            setCommunication((prev) => prev.filter((type) => type.communicationId !== id));
        } catch (err: any) {
            setError("Failed to delete communication. " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return {
        communication,
        setCommunication,
        loading,
        error,
        handleAdd,
        handleUpdate,
        handleDelete,
    };
};

export default useCommunication;